

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 存储sessionStorage
 */
export const setSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSession = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除sessionStorage
 */
export const removeSession = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}

/**
 * 获取多语言对应的api
 */
export const getLanguageUrl = (url) => {
  let languageData = {
    "zh_CN": "",//中文简体
    "en_US": "EN",//英文
    "zh_TW": "TW",//中文繁体
    "th_TH": "TH",//泰文
  }
  let localeLanguage = getStore("localeLanguage")
  if (!localeLanguage) {
    localeLanguage = "zh_CN"
  }
  if (localeLanguage == 'zh_CN') {
    return url
  }
  return url + `/${languageData[localeLanguage]}`
}

/**
 * 获取多语言图片后缀
 */
export const getImageLanguage = () => {
  let languageData = {
    "zh_CN": "cn",//中文简体
    "en_US": "en",//英文
    "zh_TW": "tw",//中文繁体
    "th_TH": "th",//泰文
  }
  let localeLanguage = getStore("localeLanguage")
  if (!localeLanguage) {
    return "cn"
  }
  return languageData[localeLanguage]
}



/**
 * 判断是否ipad
 */
export const isIpad = () => {
  var result = window.matchMedia("(min-width: 1025px)").matches;
  return !result
}

/**
 * 判断ipad横竖屏
 */
export const isIpadDirection = () => {
  let type = 1
  if (window.orientation === 180 || window.orientation === 0) {//竖屏
    console.log("竖屏")
    type = 1
  }
  if (window.orientation === 90 || window.orientation === -90) {//横屏
    type = 2
    console.log("横屏")
  }
  return type
}

/**
 * 判断是否移动端
 */
export const isMobile = () => {
  return navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
}


//   //为ipad横屏添加样式
//   function hengshuping(){
//     if(window.orientation===180||window.orientation===0){//竖屏
//         document.getElementsByTagName('body')[0].classList.remove('ipadheng');
//     }
//     if(window.orientation===90||window.orientation===-90){//横屏
//         document.getElementsByTagName('body')[0].classList.add('ipadheng');
//     }
// }
// window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", hengshuping, false);



// -拷贝
export function clone(obj) {
  // Handle the 3 simple types, and null or undefined
  if (obj == null || typeof obj !== 'object') return obj

  // Handle Date
  if (obj instanceof Date) {
    const copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }

  // Handle Array
  if (obj instanceof Array) {
    const copy = []
    for (let i = 0, len = obj.length; i < len; ++i) {
      copy[i] = clone(obj[i])
    }
    return copy
  }

  // Handle Object
  if (obj instanceof Object) {
    const copy = {}
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr])
    }
    return copy
  }

  throw new Error("Unable to copy obj! Its type isn't supported.")
}
// 判断是否为字符串
export function isString(str) {
  return (typeof str == 'string') && str.constructor == String;
}

// 跳转到用户隐私页面
export function getPrivacy() {
  window.open('https://oss.transtalent.cn/')
}

// 跳转到使用条款页面
export function getTerms() {
  window.open('https://terms.transtalent.cn/')
}

export function downLoadFile(name, data) {
  if(!data) return
  let fileUrl = window.URL.createObjectURL(new Blob([data]))
  let a = document.createElement('a')
  a.style.display = 'none'
  a.href = fileUrl
  a.setAttribute('download', name ? name : Date.now().valueOf())
  a.setAttribute('target', '_blank')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(fileUrl)
}

// 检验元素是否文字超出el dom
export function textLengthJudgeOnTooltip(el) {
  const textContent = el
  const targetW = textContent.getBoundingClientRect().width
  const range = document.createRange()
  range.setStart(textContent, 0)
  range.setEnd(textContent, textContent.childNodes.length)
  const rangeWidth = range.getBoundingClientRect().width
  return rangeWidth > targetW
}

/**
 * 新版提示框组件配置
 * @param message 标题
 * @param iconType 图标类型
 * @param duration 时长，默认2000
 * @param showPosType 位置
 * @param content 内容
 */
export function getTipBoxOption(title,iconType,showPosType,content,duration){
  let option = {
    message: title,
    iconUrl: "",
    duration: duration ? duration : 2000,
    showType: showPosType ? showPosType : "top",
    contentMessage: content ? content : ""
  }
  switch (iconType){
    case "success":
      option.iconUrl = require("@/assets/image/message/top-success.png");
      break;
    case "warning":
      option.iconUrl = require("@/assets/image/message/top-warning.png");
      break;
    case "warning2":
      option.iconUrl = require("@/assets/image/message/top-warning-y.png");
      break;
    case "error":
      option.iconUrl = require("@/assets/image/message/top-error.png");
      break;
    case "loading":
      option.iconUrl = require("@/assets/image/message/loading.gif");
      break;
    default:
      option.iconUrl = require("@/assets/image/message/top-success.png");
      break;
  }
  return option;
}

//获取字符的字节数量
export function getStrLength(str) {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    let c = str.charAt(i);
    if (/^[\u0000-\u00ffA-Za-z1-9]+$/.test(c)) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
}

//获取栅栏宽度 fenceCount总栏数，计算方式：(vw-368-Margin*2)/24  得到栏宽，再用这个栏宽去乘以总栏数 + 栅栏间隔16 * (总栏数 - 1)
export function getFenceWidth(fenceCount){
  let width = window.document.body.clientWidth;
  console.log('屏幕宽度',width)
  let margin = 16;
  let domWidth = (width - 368 - (margin * 2)) / 24;
  return (domWidth * fenceCount) + (margin * (fenceCount - 1));
}

//版本检查：根据本地缓存的版本信息和服务器的版本信息进行对比
export function versionExamine(timestamp){
  let storage_version = localStorage.getItem('versionData');
  if(storage_version){//本地有版本信息则进行对比
    if(Number(timestamp) !== Number(storage_version)){
      localStorage.setItem('versionData',timestamp);
      console.log('强制刷新页面~~');
      location.reload();
    }
  }else{//没有的话先存下版本信息，再进行刷新页面
    localStorage.setItem('versionData',timestamp);
    console.log('强制刷新页面~~');
    location.reload();
  }
}

/**
 * 检查当前页面是否是腾讯模块页面
 * 通过检查URL参数中是否包含moduleId来判断
 * 如果包含moduleId，表示当前页面是腾讯模块页面，返回true
 * 如果不包含moduleId，但sessionStorage中有txModuleId，则将moduleId拼接到当前URL后并返回true
 * 如果既没有moduleId也没有txModuleId，返回false
 * 如果没有moduleId但有txModuleId时，检查是否有backUrl：
 *   - 如果有backUrl，则删除txModuleId并返回false
 *
 * @returns {boolean} 如果是腾讯模块页面返回true，否则返回false
 */
export function checkAndSetModuleId(id) {
  try {
    const moduleId = id; // 获取 moduleId
    // 如果 URL 中有 moduleId
    if (moduleId) {
      console.log('从 Query 中获取到 moduleId:', moduleId);
      // 将 moduleId 存储到 sessionStorage 中
      setSession('txModuleId', moduleId)
      return true; // 返回 true 表示是腾讯模块页面
    }
    // 如果既没有 moduleId 也没有 txModuleId
    console.warn('当前页面 moduleId');
    removeSession('txModuleId'); // 清除 sessionStorage 中的 txModuleId
    return false; // 返回 false 表示不是腾讯模块页面
  } catch (error) {
    console.error('检查 moduleId 时发生错误:', error);
    return false; // 发生错误时返回 false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js